import useAuthStore from '@/features/auth/stores/authStore';
import { GatekeeperModal } from '@/features/profile';
import * as React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Header from './Header';

export const AuthorizedLayout = () => {
  const isAuthorized = useAuthStore((x) => x.isAuthorized);
  const authorized = isAuthorized();
  const currentUrl = encodeURI(window.location.href);
  const redirectUrl = `/login?redirectUrl=${currentUrl}`;

  return authorized ? (
    <>
      <GatekeeperModal />
      <Header />
      <div className="w-screen overflow-x-hidden overflow-y-auto h-screen-without-header">
        <div className="px-4 pt-8 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <main className="relative flex-1 focus:outline-none">
            <Outlet />
          </main>
        </div>
      </div>
    </>
  ) : (
    <Navigate to={redirectUrl} />
  );
};
